import { bonusStore } from "@/shared/stores/BonusStore";
import { userStore } from "@/shared/stores/UserStore";
import { useEffect } from "react";
import { useBetUpdates } from "../SocketProvider";
import type { BetSocketEvent } from "../types";

export const useBalanceUpdater = (options?: {
  enabled?: boolean;
}): {
  lastBet: BetSocketEvent | null;
  isEnabled: boolean;
} => {
  const { enabled = true } = options || {};
  const { lastBet } = useBetUpdates();

  useEffect(() => {
    if (!enabled || !lastBet) return;
    userStore.handleBetEvent(lastBet);
    if (bonusStore.isActive && (lastBet.type === "bet.settled" || lastBet.type === "bet.canceled")) {
      bonusStore.reset();
      bonusStore.fetchCurrent();
    }
  }, [lastBet, enabled]);

  return {
    lastBet,
    isEnabled: enabled,
  };
};
